(function () {
  'use strict';

  var GROUPS = [
    {
      handles: ['cellulite-cup-olie', 'cellulite-cup-olie-2', 'cellulite-cup-olie-3'],
      mostPopular: null,
    },
    {
      handles: ['mkbm-msm-vitamin-c-3000-mg', 'msm-vitamin-c-2-pack'],
      mostPopular: 'msm-vitamin-c-2-pack',
    },
    {
      handles: ['tropical-marine-collageen', 'beauty-marine-collagen-tropical-2-pack'],
      mostPopular: null,
    },
    {
      handles: ['cellulite-cups-cellulite-olie', 'the-ultimate-anti-cellulite-bundle'],
      mostPopular: null,
    },
  ];

  var FREE_SHIPPING_THRESHOLD = 8000;

  function formatMoney(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function getGroup(handle) {
    return GROUPS.find(function (g) {
      return g.handles.indexOf(handle) !== -1;
    }) || null;
  }

  function fetchProduct(handle) {
    return fetch('/products/' + handle + '.js').then(function (r) { return r.json(); });
  }

  function getBadge(product, group, products) {
    if (group.mostPopular === product.handle) {
      return { text: 'MEEST POPULAIR', style: 'highlight' };
    }

    var price = product.price;
    var comparePrice = product.compare_at_price;
    var hasFreeShipping = price >= FREE_SHIPPING_THRESHOLD;

    var savings = comparePrice && comparePrice > price
      ? Math.round((1 - price / comparePrice) * 100)
      : 0;

    var maxSavings = Math.max.apply(null, products.map(function (p) {
      return p.compare_at_price && p.compare_at_price > p.price
        ? Math.round((1 - p.price / p.compare_at_price) * 100)
        : 0;
    }));

    var isBestDeal = savings > 0 && savings === maxSavings && !group.mostPopular;

    if (hasFreeShipping && isBestDeal) {
      return { text: 'MEEST VOORDEEL + Gratis verzending', style: 'highlight' };
    }
    if (hasFreeShipping) {
      return { text: 'Gratis verzending', style: 'highlight' };
    }
    if (isBestDeal) {
      return { text: 'MEEST VOORDEEL', style: 'highlight' };
    }

    return null;
  }

  function checkSvg(active) {
    return '<div class="qb-check">'
      + '<svg class="qb-check-icon" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">'
      + '<circle cx="11" cy="11" r="10" stroke="#cccccc" stroke-width="2" fill="white" class="qb-check-circle"' + (active ? ' style="display:none"' : '') + '/>'
      + '<circle cx="11" cy="11" r="10" stroke="#3a7a3a" stroke-width="2" fill="#3a7a3a" class="qb-check-filled"' + (!active ? ' style="display:none"' : '') + '/>'
      + '<path d="M6.5 11L9.5 14L15.5 8" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="qb-check-tick"' + (!active ? ' style="display:none"' : '') + '/>'
      + '</svg>'
      + '</div>';
  }

  function buildOption(product, currentHandle, badge) {
    var isCurrent = product.handle === currentHandle;
    var price = product.price;
    var comparePrice = product.compare_at_price;
    var image = product.images && product.images[0] ? product.images[0] : '';

    var savings = null;
    if (comparePrice && comparePrice > price) {
      var pct = Math.round((1 - price / comparePrice) * 100);
      savings = 'BESPAAR ' + pct + '%';
    }

    var perUnit = null;
    var qty = product.title.match(/(\d+)[\s-]pack/i) || product.title.match(/(\d+)\s+potten/i);
    if (qty) {
      perUnit = formatMoney(Math.round(price / parseInt(qty[1], 10))) + ' per stuk';
    }

    var tag = isCurrent ? 'div' : 'a';
    var href = isCurrent ? '' : ' href="/products/' + product.handle + '"';

    var html = '<' + tag + ' class="qb-option' +
      (isCurrent ? ' qb-active' : '') + '"' + href + '>';

    if (badge) {
      html += '<div class="qb-badge qb-badge--green">' + badge.text + '</div>';
    }

    html += '<div class="qb-row">';
    html += checkSvg(isCurrent);

    html += '<div class="qb-img-wrap">';
    if (image) {
      html += '<img src="' + image + '" class="qb-img" alt="' + product.title + '">';
    } else {
      html += '<div class="qb-img-placeholder"></div>';
    }
    html += '</div>';

    html += '<div class="qb-info">';
    html += '<div class="qb-option-label">' + product.title + '</div>';
    html += '<div class="qb-option-meta">';
    if (savings) html += '<span class="qb-savings-pill">' + savings + '</span>';
    if (perUnit) html += '<span class="qb-sublabel">' + perUnit + '</span>';
    html += '</div>';
    html += '</div>';

    html += '<div class="qb-price-wrap">';
    html += '<span class="qb-price">' + formatMoney(price) + '</span>';
    if (comparePrice && comparePrice > price) {
      html += '<span class="qb-price-old">' + formatMoney(comparePrice) + '</span>';
    }
    html += '</div>';

    html += '</div>';
    html += '</' + tag + '>';

    return html;
  }

  function build(wrap, currentHandle, group) {
    Promise.all(
      group.handles.map(function (handle) {
        return fetchProduct(handle);
      })
    ).then(function (products) {
      var html = '<div class="qb-title">Kies jouw pakket</div>';
      html += '<div class="qb-grid">';

      products.forEach(function (product) {
        var badge = getBadge(product, group, products);
        html += buildOption(product, currentHandle, badge);
      });

      html += '</div>';
      wrap.innerHTML = html;
      wrap.style.display = 'block';
    }).catch(function (err) {
      console.warn('qty-break: kon producten niet laden', err);
    });
  }

  function init() {
    var wrap = document.getElementById('qty-break-selector');
    if (!wrap) return;

    // Alleen tonen voor variant_b van pdp_v2
    var variant = document.documentElement.getAttribute('data-abt-pdp');
    if (variant !== 'variant_b') return;

    var handle = wrap.getAttribute('data-handle');
    if (!handle) return;

    var group = getGroup(handle);
    if (!group) return;

    build(wrap, handle, group);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
